/*
 * @Author: Chris 
 * @Date: 2022-07-28 10:58:52 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-11 11:46:45
 */
 
<template>
  <div class="PAGE_OUTSTYLE">
    <el-card class="menuManagement_card">
      <div class="card_header">
        <div class="left-btn">
          <el-radio-group v-model="searchType" @change="handleType">
            <el-radio-button label="0">启翼PC</el-radio-button>
            <el-radio-button label="1">启翼APP</el-radio-button>
          </el-radio-group>
        </div>
        <div>
        </div>
      </div>
      <div class="card_header">
        <div class="left-btn">
          <el-select
            size="medium"
            v-model="companyType"
            @change="getMenuListMethods"
            placeholder="请选择公司类型"
            clearable>
            <el-option
              v-for="item in companyTypeList"
              :key="item.id"
              :label="item.unitName"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <div class="header_rightadd" @click="handAdd()">新增菜单</div>
        </div>
      </div>
      <div class="card_body">
        <el-table
          :header-cell-style="{ background: '#EBEBEB', color: '#333' }"
          :data="tableData"
          @cell-dblclick="this.$dblClickCopy"
          style="width: 100%"
          height="100%"
          row-key="id"
          border
          v-loading="loading"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column type="sort" label="排序号" align="center" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.sort}}</span>
            </template>
          </el-table-column>
          <el-table-column label="菜单名称" prop="permissionName" min-width="160">
          </el-table-column>
          <el-table-column label="上级菜单" prop="parentName">
          </el-table-column>
          <el-table-column label="类型" prop="type">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.type == 0"
                disable-transitions
                effect="plain"
                size="mini">菜单</el-tag>
              <el-tag
                v-else-if="scope.row.type == 1"
                disable-transitions
                type="success"
                effect="plain"
                size="mini">按钮</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="公司类型" prop="permissionName" min-width="100">
            <template slot-scope="scope">
              <span>{{getName(scope.row.unitCode)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否可分配" prop="distributable">
            <template slot-scope="scope">
              <span v-if="scope.row.distributable == 0">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column label="授权标识" prop="permissionCode" min-width="160"></el-table-column>
          <el-table-column label="路由地址" prop="uri" min-width="160"></el-table-column>
          <el-table-column label="是否外链" prop="linke">
            <template slot-scope="scope">
              <span v-if="scope.row.linke == 1">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" label="操作">
            <template slot-scope="scope">
              <el-link
                class="table_link"
                target="_blank"
                @click="handAdd(scope.row)"
              >
                <i class="el-icon-circle-plus-outline"></i>新增
              </el-link>
              <el-link
                class="table_link"
                target="_blank"
                @click="handEidt(scope.row)"
              >
                <i class="el-icon-edit"></i>编辑
              </el-link>
              <el-link
                class="table_link"
                target="_blank"
                @click="handDelete(scope.row)"
              >
                <i class="el-icon-delete"></i>删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 列表编辑框 -->

    <ModifyCompanyInformationDrawer
      :show.sync="show"
      :row="chooseRow"
      :type="type"
      :permissionType="searchType"
      :unitCode="companyType"
      :treeData="tableData"
      :companyTypeList="companyTypeList"
      @getMenuListMethods="getMenuListMethods"
    ></ModifyCompanyInformationDrawer>
  </div>
</template>

<script>
import {
  getCompanyTypeList,
  menuList,
  menuAdd,
  menuDelete
} from "../../api/api";
import ModifyCompanyInformationDrawer from "../menuManagement/components/companyInformation";
export default {
  name: "menuManagement",
  components: {
    ModifyCompanyInformationDrawer,
  },
  data() {
    return {
      searchType: 0,
      companyType: null,
      tableData: [],
      loading: false,
      companyTypeList: [],

      chooseRow: null,
      type: 'add',
      show: false
    };
  },
  async mounted() {
    await this.initCompanys();
    this.getMenuListMethods();
  },
  methods: {
    getName(code) {
      let name = '';
      for(let item of this.companyTypeList) {
        if (code == item.id) {
          name = item.unitName
        }
      }
      return name
    },
    // 初始化单位
    initCompanys() {
      return getCompanyTypeList().then(res => {
        if (res.code === 200) {
          this.companyTypeList = res.data || [];
          if(this.companyTypeList.length) {
            this.companyType = this.companyTypeList[0].id
          }
        }
      })
    },
    createMenu() {
      let list = [];
      this.initUnitMenu(list)
    },
    // 复制脚本
    async initUnitMenu(tree, parentId = -1) {
      for (let item of tree) {
        const params = {
          ...item,
          parentId,
          unitCode: 1
        }
        delete params.id
        params.children && delete params.children
        const res = await menuAdd(params)
        if (item.children && item.children.length) {
          await this.initUnitMenu(item.children, res.data.id)
        }
      }
    },
    handleType(type) {
      this.searchType = type
      this.getMenuListMethods();
    },

    handleCompanyType() {

    },

    /**
     * 获取菜单列表
     * */
    getMenuListMethods() {
      this.loading = true;
      let params = {
        permissionType: this.searchType,
        unitCode: this.companyType,
        type: null
      };
      menuList(params).then((res) => {
        this.tableData = res.data || [];
      }).finally(() => {
        this.loading = false;
      })
    },

    // 新增
    handAdd(row) {
      this.type = 'add';
      this.chooseRow = row;
      this.show = true;
      console.log('handAdd:新增：', this.show, this.type, this.chooseRow)
    },

    /**
     * 修改信息
     * 打开右侧抽屉
     * */
    handEidt(e) {
      this.chooseRow = e;
      this.type = 'edit';
      this.show = true;
    },

    // 删除
    handDelete(row) {
      
      this.$confirm(
        "是否确认删除该菜单？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let params = {
            id: row.id,
          };
          menuDelete(params).then((res) => {
            if (res.code == 200) {
              this.getMenuListMethods();
              this.$notify.success({
                title: "成功",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {});
    }

  },
};
</script>

<style lang="scss" scoped>
.menuManagement_card :deep(.el-link.el-link--danger) {
  color: #b7282d;
}
.menuManagement_card :deep(.el-link.el-link--success) {
  color: #27c57c;
}
.menuManagement_card :deep(.el-link.el-link--default) {
  color: #333333;
}

.menuManagement_card {
  // height: calc(100% - 0.625rem);

  .card_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.125rem;
    .header_leftSearch {
      width: 15.4375rem;
    }
    .left-btn {
      display: flex;
      align-items: center;
      ::v-deep .el-radio-button__inner:hover {
        color: #b7282d;
      }
      ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        color: #ffffff;
        background-color: #b7282d;
        border-color: #b7282d;
        box-shadow: -1px 0 0 0 #b7282d;
      }
    }
    .header_rightadd {
      width: 5.75rem;
      height: 2rem;
      background: #b7282d;
      border-radius: 0.25rem;
      color: #ffffff;
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
      cursor: pointer;
    }
  }
  .card_body {
    margin-top: 10px;
    height: calc(100vh - 249px);
    overflow-y: auto;

    .com_name {
      display: flex;
      align-items: center;
      .com_logo {
        width: 3.625rem;
        height: 3.625rem;
        border-radius: 0.25rem;
        margin-right: 0.75rem;
      }
    }

    .tableState_red {
      border: 0.0625rem solid #f84638;
      border-radius: 0.9375rem;
      color: #f84638;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.5rem;
      height: 1.3125rem;
    }

    .tableState_green {
      border: 0.0625rem solid #27c57c;
      border-radius: 0.9375rem;
      color: #27c57c;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.5rem;
      height: 1.3125rem;
    }

    .table_link {
      margin-right: 1rem;
      .ICON_ {
        width: 0.8125rem;
        height: 0.8125rem;
      }
    }
    .table_link :nth-last-child(1) {
      margin-right: 0rem;
    }
  }

  .drawer_header {
    width: 100%;
    border-top: 0.125rem solid #eeeeee;
  }
}
::v-deep .is-scrolling-none {
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
}
</style>